// Number and text formatting for the UI.

const nf = new Intl.NumberFormat("en-GB");

export const fmtInt = (n: number) => nf.format(Math.round(n));

/** Compact deaths: 1,234 · 12k · 1.2M (estimates are never more precise than that). */
export function fmtDeaths(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n) || n <= 0) return "—";
  if (n < 1000) return nf.format(Math.round(n));
  if (n < 10_000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "")}k`;
  if (n < 1_000_000) return `${Math.round(n / 1000)}k`;
  return `${(n / 1_000_000).toFixed(n < 10_000_000 ? 1 : 0).replace(/\.0$/, "")}M`;
}

export const DEATH_SOURCES: Record<string, string> = {
  ucdp: "UCDP (recorded deaths in organised violence)",
  cow: "Correlates of War (battle deaths)",
  wikidata: "Wikidata (total deaths, as cited)",
};

export const SOURCE_NAMES: Record<string, string> = {
  wikidata: "Wikidata", cow: "Correlates of War", ucdp: "UCDP", wikipedia: "Wikipedia",
  "wikipedia-ongoing": "Wikipedia: List of ongoing armed conflicts",
};

export const TIER_LABEL: Record<string, string> = {
  major_war: "Major war (≥10,000 deaths a year)",
  minor_war: "Minor war (1,000–9,999 deaths a year)",
  conflict: "Conflict (100–999 deaths a year)",
  skirmish: "Skirmishes (<100 deaths a year)",
};

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${fmtInt(n)} ${n === 1 ? one : many}`;
}
